import { CommonModule } from '@angular/common';
import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CasePipe, CaseType } from '../../../pipes/case.pipe';

@Component({
  selector: 'app-field-container',
  imports: [CommonModule, CasePipe],
  template: `
    <div class="tw-flex tw-flex-col sm:tw-flex-row tw-items-start">
      <div
        class="tw-flex tw-items-center sm:tw-basis-[30%]"
        [class]="labelClasses"
      >
        <div [class.tw-font-bold]="bold" class="tw-pr-1 tw-pt-2">
          {{ label | case: labelCase }} {{ required ? '*' : '' }}
        </div>
      </div>
      <div class="sm:tw-basis-[70%]" [class]="valueClasses">
        <ng-container *ngTemplateOutlet="valueTemplate"></ng-container>
      </div>
    </div>
  `,
  styles: ``,
})
export class FieldContainerComponent {
  @ContentChild('value')
  valueTemplate: TemplateRef<any>;

  @Input()
  label: string;

  @Input()
  labelCase: CaseType = 'sentence';

  @Input()
  valueClasses: string;

  @Input()
  labelClasses: string;

  @Input()
  bold = true;

  @Input()
  control: FormControl;

  protected get required(): boolean {
    return this.control?.hasValidator(Validators.required);
  }
}
